/**
 * Provides service functions for retrieving application translation
 * resources used to support multilingual content across the application.
 */
import { api } from "@/api";

export async function getTranslations(): Promise<any> {
  const res = await api.translations();
  return res;
}
